import React from 'react';

const WhatsAppSupportLink = ({supportMessage}) => {
  const phoneNumber = import.meta.env.VITE_SUPPORT_NUMBER; // Replace with your support number
  const message = "Hello, I need help with my withdrawal."; // Custom message
  const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;

  return (
    <a 
      href={whatsappUrl} 
      target="_blank" 
      rel="noopener noreferrer"
      className="flex items-center space-x-2 px-4 py-2 bg-gradient-to-r from-green-400 to-green-600 text-white font-semibold rounded-lg shadow-lg hover:shadow-xl transition-transform transform hover:scale-105"
    >
      <svg
        className="w-6 h-6"
        xmlns="http://www.w3.org/2000/svg"
        fill="currentColor"
        viewBox="0 0 16 16"
      >
        <path d="M13.601 2.399A7.931 7.931 0 0 0 8 0C3.58 0 0 3.581 0 7.998a7.963 7.963 0 0 0 1.13 4.113L0 16l3.996-1.117A7.951 7.951 0 0 0 8 15.998c4.42 0 8-3.581 8-7.998a7.932 7.932 0 0 0-2.399-5.601zM8 14.498c-1.32 0-2.57-.344-3.662-.992l-.26-.154-2.37.66.654-2.308-.168-.276a6.438 6.438 0 0 1-1.018-3.426c0-3.558 2.906-6.462 6.462-6.462 1.727 0 3.35.675 4.574 1.9a6.428 6.428 0 0 1 1.887 4.574c0 3.556-2.906 6.462-6.462 6.462z" />
        <path d="M11.515 9.994c-.282-.141-1.672-.826-1.93-.92-.257-.095-.446-.141-.635.14-.188.28-.725.92-.888 1.107-.163.188-.325.21-.606.07-.282-.14-1.19-.438-2.268-1.395-.84-.748-1.41-1.673-1.577-1.955-.163-.282-.017-.435.123-.574.126-.125.282-.326.423-.487.14-.163.188-.282.282-.47.093-.188.047-.35-.024-.487-.07-.141-.634-1.524-.87-2.089-.226-.544-.457-.471-.635-.471-.165 0-.351-.024-.542-.024-.188 0-.487.07-.74.35-.257.28-.97.95-.97 2.31 0 1.357 1 2.668 1.142 2.855.141.188 1.964 3.002 4.767 4.096.666.287 1.184.458 1.588.624.667.212 1.273.182 1.754.111.536-.08 1.672-.684 1.907-1.346.236-.66.236-1.226.165-1.346-.07-.12-.257-.188-.54-.326z" />
      </svg>
		<p> {supportMessage} </p>
    </a>
  );
};

export default WhatsAppSupportLink;

